import styled from 'styled-components';

import AddSharpIcon from '@mui/icons-material/AddSharp';
import RemoveSharpIcon from '@mui/icons-material/RemoveSharp';

export const DropdownTogglerWrapper = styled.button<{ $isOpen: boolean }>`
    width: 40px;
    height: 40px;
    background-color: ${({ $isOpen, theme }) => ($isOpen ? theme.Utility.cta : theme.Surface.Opposite.secondary)};
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 8px 20px 0 0;
`;

export const StyledAddIcon = styled(AddSharpIcon)`
    fill: ${({ theme }) => theme.Surface.primary};
`;

export const StyledRemoveIcon = styled(RemoveSharpIcon)`
    fill: ${({ theme }) => theme.Surface.primary};
`;
